export function interpolateArray(arr, errorThreshold = 0.2) {
    const nullCount = arr.filter(val => val === null).length;
    const maxNulls = Math.floor(arr.length * errorThreshold);

    if (nullCount > maxNulls) {
        console.warn('Null values exceed the error threshold. No interpolation performed.');
        return arr;
    }

    const interpolate = (arr, i) => {
        let left = i - 1;
        let right = i + 1;

        // Find the nearest non-null left value
        while (left >= 0 && arr[left] === null) {
            left--;
        }

        // Find the nearest non-null right value
        while (right < arr.length && arr[right] === null) {
            right++;
        }

        if (left >= 0 && right < arr.length) {
            const interpolatedValue = arr[left] + (arr[right] - arr[left]) * (i - left) / (right - left);
            arr[i] = interpolatedValue;
        }
    };

    for (let i = 0; i < arr.length; i++) {
        if (arr[i] === null) {
            interpolate(arr, i);
        }
    }

    return arr;
}

